import { render, staticRenderFns } from "./cCard.vue?vue&type=template&id=0b52bed4&"
import script from "./cCard.vue?vue&type=script&lang=js&"
export * from "./cCard.vue?vue&type=script&lang=js&"
import style0 from "./cCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports